"use strict";

import firebase from "firebase";
import config from "config";
import moment from "moment";

firebase.initializeApp({
  databaseURL: config.databaseURL,
  apiKey: config.dbApiKey,
  projectId: config.dbProjectId,
});

let db = firebase.database();

export function SendPayment(token) {
  return new Promise((resolve, reject) => {
    try {
      db.ref("payments/" + token.id).set(token);
    } catch (e) {
      reject(e);
    }
  });
}

export function SubmitEmail(email, name) {
  return new Promise((resolve, reject) => {
    try {
      db.ref("requests/creatorGetStarted").push({
        landingPage: "sales_page",
        email: email || null,
        name: name || null,
        signupDate: moment().format("MM-DD-YY h:mma"),
      });
    } catch (e) {
      reject(e);
    }
  });
}

export function AthleteUseAccessCode(accessCode, profile) {
  return new Promise((resolve, reject) => {
    try {
      const joinReq = db.ref("requests/athleteUseAccessCode").push();

      joinReq.set({
        accessCode,
        profile,
      });

      joinReq.child("response").on("value", (respSnap) => {
        const response = respSnap.val();
        if (!response) return;

        if (response.success) {
          resolve("Success");
        } else if (response.error) {
          resolve(response.error);
        }
      });
    } catch (e) {
      reject(e);
    }
  });
}

export function BoxPay(token) {
  return new Promise((resolve, reject) => {
    try {
      const req = db.ref("requests/boxPayForExistingTrybe/").push();
      //Listen and resolve if success
      req.child("response").on("value", (snap) => {
        const response = snap.val();
        if (response && response.accessUrl) {
          resolve(response.accessUrl);
        }
      });

      req.set(token);
    } catch (e) {
      reject(e);
    }
  });
}

export function DHRCoachPay(token) {
  return new Promise((resolve, reject) => {
    try {
      const req = db.ref("requests/dhrCoachPayAccessCode/").push();
      //Listen and resolve if success
      req.child("response").on("value", (snap) => {
        const response = snap.val();
        if (response && response.accessUrl) {
          resolve(response.accessUrl);
        }
      });

      req.set(token);
    } catch (e) {
      reject(e);
    }
  });
}

export const InitUserAcct = (data) => {
  const path = db.ref(`users/${data.userId}`);

  let favs = null;
  const emailConsentObj = {};
  emailConsentObj[data.coachOrgId || "general"] = {
    consentDate: Date.now(),
    consentPrompt: data.emailConsentPrompt,
  };
  const emailConsent = data.emailConsent ? emailConsentObj : null;

  const waiverConsentObj = {};
  waiverConsentObj[data.coachOrgId || "general"] = {
    consentDate: Date.now(),
  };

  if (data.primarySurveyResponse) {
    favs = {
      [data.coachOrgId]: {
        programs: [data.primarySurveyResponse],
      },
    };
  }

  path.update({
    metadata: {
      coachOrgId: data.coachOrgId || "",
    },
    profile: {
      createdAt: Date.now(), //a timestamp
      email: data.email,
      firstname: data.firstname,
      lastname: data.lastname,
      trybe: data.coachOrgId, //needed? If so, need to create unique trybe for each coachOrg
      userId: data.userId,
    },
    consents: {
      email: emailConsent,
      waiver: waiverConsentObj,
    },
    favs,
  });
};

export const InitDemoAcct = (data) => {
  const path = db.ref(`users/${data.userId}`);
  let trialEndDate = new Date(); // Now
  trialEndDate.setDate(trialEndDate.getDate() + 30); // Set now + 30 days as the new trialEndDate
  const staticDate = trialEndDate.getTime();

  let favsData = {};
  let paidAccessData = {};

  switch (data.coachOrgId) {
    case "-LW2M4tJakuYczP6HfZv":
      paidAccessData = {
        "-LW2M4tJakuYczP6HfZv": {
          accessEnd: staticDate,
          accessType: "coach_org_all_access",
          coachOrgId: "-LW2M4tJakuYczP6HfZv",
        },
      };
      break;
    case "-LW2M4tJakuYczP6HfZz":
      paidAccessData = {
        "-LW2M4tJakuYczP6HfZz": {
          accessEnd: staticDate,
          accessType: "coach_org_all_access",
          coachOrgId: "-LW2M4tJakuYczP6HfZz",
        },
      };
      break;
    case "-LW2M4tJakuYczP6HfZq":
      paidAccessData = {
        "-LW2M4tJakuYczP6HfZq": {
          accessEnd: staticDate,
          accessType: "coach_org_all_access",
          coachOrgId: "-LW2M4tJakuYczP6HfZq",
        },
      };
      break;
    case "-LW2M4tJakuYczP6HfZr":
      paidAccessData = {
        "-LW2M4tJakuYczP6HfZr": {
          accessEnd: staticDate,
          accessType: "coach_org_all_access",
          coachOrgId: "-LW2M4tJakuYczP6HfZr",
        },
      };
      break;
    case "-NNJaFoGcfkDOcu9aMkk":
      paidAccessData = {
        "-NNJaFoGcfkDOcu9aMkk": {
          accessEnd: staticDate,
          accessType: "coach_org_all_access",
          coachOrgId: "-NNJaFoGcfkDOcu9aMkk",
        },
      };
      break;
    case "-NibzYAz4PSzmclOJPfC":
      paidAccessData = {
        "-NibzYAz4PSzmclOJPfC": {
          accessEnd: staticDate,
          accessType: "coach_org_all_access",
          coachOrgId: "-NibzYAz4PSzmclOJPfC",
        },
      };
      break;
    case "-NkPMsdor32P-x7uNBtO":
      paidAccessData = {
        "-NkPMsdor32P-x7uNBtO": {
          accessEnd: staticDate,
          accessType: "coach_org_all_access",
          coachOrgId: "-NkPMsdor32P-x7uNBtO",
        },
      };
      break;
    default:
      paidAccessData = {
        "-LW2M4tJakuYczP6HfZq": {
          accessEnd: staticDate,
          accessType: "coach_org_all_access",
          coachOrgId: "-LW2M4tJakuYczP6HfZq",
        },
      };
  }

  if (Object.keys(paidAccessData).length === 0) {
    return;
  }

  path.update({
    metadata: {
      coachOrgId: data.coachOrgId,
    },
    profile: {
      createdAt: Date.now(), //a timestamp
      email: data.email,
      firstname: data.firstname,
      lastname: data.lastname,
      trybe: data.coachOrgId, //needed? If so, need to create unique trybe for each coachOrg
      userId: data.userId,
    },
    paidAccess: {
      coachOrgs: paidAccessData,
    },
  });
};

export const fetchCoachName = async (orgId) => {
  try {
    const path = `coachOrgs/${orgId}/coachName`;
    const name = await db
      .ref(path)
      .once("value")
      .then((s) => s.val());
    return name;
  } catch (e) {
    console.log("e", e);
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/api/signup.api.js